import {
  fetchPriceFailure,
  fetchPriceSuccess,
  PriceActionTypes,
} from "actions";
import { SagaIterator } from "redux-saga";
import { call, delay, put, takeLatest } from "redux-saga/effects";
import { ApiBaseUrl } from "utils";

export interface IPrice {
  price: number;
  volume_24h: number;
  volume_change_24h: number;
  percent_change_1h: number;
  percent_change_24h: number;
  percent_change_7d: number;
  percent_change_30d: number;
  percent_change_60d: number;
  percent_change_90d: number;
  market_cap: number;
  market_cap_dominance: number;
  fully_diluted_market_cap: number;
  tvl: any;
  last_updated: string;
}

const fetchPriceApi = async () => {
  const response = await fetch(
    ApiBaseUrl + `/api/stats/price?slug=bbachain&convert=USD`
  );

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  const { data } = await response.json();
  return data;
};

// Worker Saga
function* fetchPriceData(): SagaIterator {
  try {
    const data: IPrice = yield call(fetchPriceApi);
    yield put(fetchPriceSuccess(data));
  } catch (error: any) {
    yield put(fetchPriceFailure(error.message || "Unknown error occurred"));
  }
}

function* autoReloadPriceData() {
  while (true) {
    yield call(fetchPriceData); // call fetchPriceData
    yield delay(10 * 1000); // Wait for 10 seconds
  }
}

// Watcher Saga
export function* watchPriceSaga() {
  yield takeLatest(PriceActionTypes.FETCH_PRICE_REQUEST, autoReloadPriceData);
}
